'use strict';

exports.__esModule = true;
exports['default'] = {
  background: {
    image: '/background-blurred.jpg',
    size: 'cover'
  },
  props: {
    'tournamentId': ':tournamentId'
  },
  title: function title(getState, props) {
    return getState().tournaments.byId[props.tournamentId].name;
  },
  type: 'Tournament'
};
module.exports = exports['default'];